import React, { Component } from "react";
import registered from "../static/img/registered.jpg"
import registered_cn from "../static/img/registered_cn.jpg"
// import 'react-flags-select/css/react-flags-select.css';
import Navbar from 'react-bootstrap/Navbar'

export default class Header extends Component {
	render() {
		return (
			<Navbar className="justify-content-center footer" bg="dark" variant="dark">
				<div className="footer-div">
					<Navbar.Brand>
						<img
							src={this.props.language === 'CN'
								? registered_cn
								: registered}
							className="registered"
							alt="Logo"
						/>
					</Navbar.Brand>
					<a target="_blank" href="https://beian.miit.gov.cn"><h2 className="footer-msg">沪ICP备11022801号</h2></a>
				</div>
			</Navbar>
		);
	}
}
